<template>
  <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.9375 1.96826C17.9375 2.72881 17.323 3.34326 16.5625 3.34326H1.4375C0.676953 3.34326 0.0625 2.72881 0.0625 1.96826C0.0625 1.20771 0.676953 0.593262 1.4375 0.593262H16.5625C17.323 0.593262 17.9375 1.20771 17.9375 1.96826Z" fill="#1B1E21"/>
  </svg>
</template>